<template>
  <main>
    <crumbs :crumbs="crumbs"></crumbs>
    <div class="wrap" v-if="branch.length > 0">
      <div class="result">
        <div class="clear branch">
          <div class="swiper-container" id="swiper-branch">
            <div class="swiper-wrapper">
              <div class="swiper-slide" v-for="(item,index) in branch" @click="changeTab(item,index)">
                <div class=" item" :style="{backgroundImage:'url('+util.autoImage((tab.id == item.id ? item.bg2 : item.bg))+')'}"
                     :class="[tab.id == item.id ? 'active' : '']">
                  <div class="cen">
                    <div class="middle">
                      <div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
                      <div class="icon icon-a"><img :src="util.autoImage(item.image)" alt=""></div>
                      <div class="tit">{{ item.title }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear session">
          <div class=" list" :class="[tab.id == item.id ? 'active' : '']" v-for="(item,index) in branch">
            <div class="title-box"><span>08/21</span>{{ item.min_title }}</div>
            <div class="description">{{ item.desc }}</div>
            <div class="box">
              <div class="clear item fuck-your-sister" v-for="(v,i) in item.list" :class="[tool.array.inArray(live_active,sessionStatus(item,v,i)) ? 'active' : '']"
                   @click="toMudu(item,v,i)">
                <div class="left time-box">
                  <div class="line line-1"></div>
                  <div class=" time"><i></i>
                    <div class="t">{{ tool.date.formatDate("H:i", v.live_start) }}<br/>-<br/>{{ tool.date.formatDate("H:i", v.live_end) }}</div>
                  </div>
                  <div class="line line-2"></div>
                </div>
                <div class="left info-box">
                  <div class=" info">
                    <div class="title">{{ v.title }}</div>
                    <div class="speaker">
                      <div class="ll" v-if="v.speaker"><span>{{ v.speaker }}</span><i v-if="v.speaker_job">|</i><span>{{ v.speaker_job }}</span></div>
                      <div class="ll" v-if="v.speaker2"><span>{{ v.speaker2 }}</span><i v-if="v.speaker2_job">|</i><span>{{ v.speaker2_job }}</span></div>
                      <div class="ll" v-if="v.speaker3"><span>{{ v.speaker3 }}</span><i v-if="v.speaker3_job">|</i><span>{{ v.speaker3_job }}</span></div>
                      <div class="ll" v-if="v.speaker4"><span>{{ v.speaker4 }}</span><i v-if="v.speaker4_job">|</i><span>{{ v.speaker4_job }}</span></div>
                    </div>
                    <div class="status-box">
                      <div class="status" :class="[tool.array.inArray(live_active,sessionStatus(item,v,i)) ? 'active' : '']">
                        <p>{{ statusText(sessionStatus(item, v, i)) }}</p>
                      </div>
                      <div class="star " :class="[inStar(v) ? 'active' : '']" @click.stop="star(v,item)">
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <template v-if="false && tab_index <= 2">
                <div class="clear item" @click="toBanner">
                  <div class=" time-box">
                    <div class="line line-1"></div>
                    <div class=" time" v-show="tab_index === 0"><i></i>
                      <div class="t">17:00-17:20</div>
                    </div>
                    <div class=" time" v-show="tab_index === 1"><i></i>
                      <div class="t">16:35-16:57</div>
                    </div>
                    <div class=" time" v-show="tab_index === 2"><i></i>
                      <div class="t">16:45-17:07</div>
                    </div>
                    <div class="line line-2"></div>
                  </div>
                  <div class=" info-box">
                    <div class=" info">
                      <div class="title">AMD：绿色算力－开创数据中心新格局</div>
                      <div class="status-box">
                        <div class="status" :class="[banner_status >= 2 ? 'active' : '']">
                          <p>{{ banner_status === 1 ? "敬请期待" : banner_status === 2 ? "正在直播" : "直播回放" }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="clear item" @click="toBanner">
                  <div class=" time-box">
                    <div class="line line-1"></div>
                    <div class=" time" v-show="tab_index === 0"><i></i>
                      <div class="t">17:20-17:35</div>
                    </div>
                    <div class=" time" v-show="tab_index === 1"><i></i>
                      <div class="t">16:57-17:13</div>
                    </div>
                    <div class=" time" v-show="tab_index === 2"><i></i>
                      <div class="t">17:07-17:23</div>
                    </div>
                    <div class="line line-2"></div>
                  </div>
                  <div class=" info-box">
                    <div class=" info">
                      <div class="title">NVIDIA AI</div>
                      <div class="status-box">
                        <div class="status" :class="[banner_status >= 2 ? 'active' : '']">
                          <p>{{ banner_status === 1 ? "敬请期待" : banner_status === 2 ? "正在直播" : "直播回放" }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="s5" v-show="adv4.length > 0" style="display:none;">
      <div class="center">
        <div class="common-title">
          <div class="left title">解锁超多精彩内容3</div>
          <div class="right more" @click="util.toLink('/video')">查看更多</div>
        </div>
        <div class="content">
          <div class="list">
            <div class="item" v-for="(item,index) in adv4" v-if="index < 2" @click="playS4Video(item)">
              <div class="image-box">
                <div class="image"
                     :style="{backgroundImage:'url('+(item.image ? util.autoImage(item.image): util.autoImage(item.video)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast')+')'}">
                  <div class="play"></div>
                </div>
                <div class="tit">{{ item.category_title }}</div>
              </div>
              <div class="info">
                <div class="element-more min-tit">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m-loading" v-if="data_loading">
      <loading></loading>
    </div>
    <video-float v-if="video_info.video" :video_info="video_info" @hideVideo="video_info = {}"></video-float>
  </main>
</template>

<script>
import Crumbs from "../../components/m/Crumbs";
import Loading from "../../components/m/Loading";
import VideoFloat from "../../components/m/VideoFloat";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
export default {
	name: 'branch',
	data() {
		return {
			query:"",
			branch:[],
			tab:0,
			data_loading:true,
			service_time:0,
			time_list:[],
			now_time:0,
			adv4:[],
			video_info:{},

			live_active:[2,3,5],
			title:"",
			star_list:[],

			tab_index:0,
		}
	},
	components:{
		Loading, Crumbs,swiper, swiperSlide,VideoFloat
	},
	computed:{
		banner_status(){
			var now_time = this.now_time;
			if(now_time < this.tool.date.strtotime('2026-08-21 14:00:00')){
				return 1;
			}else if(now_time >= this.tool.date.strtotime('2026-08-21 17:30:00')){
				return 3;
			}else{
				return 2;
			}
		},
		crumbs() {
			return {title:"分论坛",min_title:"BREAKOUT SESSION"}
		},
		is_login(){
			return this.util.getAccessToken()
		},
	},
	watch:{
		now_time(newVal,oldVal){
			if(newVal > oldVal && this.util.inArray(newVal,this.time_list)){
				this.getBranch();
			}
		},
		swiper() {
			return this.$refs.mySwiper.$swiper
		},
		$route(){
			this.checkTab();
			this.setTitle();
			this.swiperInit();
		}
	},
	methods: {
		toBanner(){
			if(this.banner_status === 2){
				window.open('https://www.dellemc-solution.com/webinar-dtf/?channelId=4180876&mainId=4180876#/','_blank')
			}
			if(this.banner_status === 3){
				window.open('https://www.dellemc-solution.com/webinar-dtf/?channelId=4180876&mainId=4180876#/','_blank')
			}
		},
		changeTab(item,index){
			if(item.link){
				window.location.href = item.link
			}else{
				this.tab.id = item.id
				this.tab_index = index;
        this.$nextTick(() => {
          this.fuckSister();
        })
			}
		},
		playS4Video(item){
			item.video = item.url;
			this.video_info = item;
		},
		checkTab(){
			this.query = this.$route.query;
			if(this.query.id){
				this.tab = {
					id:this.query.id
				}
			}else{
				this.tab = {
					id:this.branch?.[0]?.id || '',
				}
			}
		},
		setTitle(){
			this.title = "分论坛";
			document.title = "分论坛-2026戴尔科技峰会";
			this.report();
		},
		report(){
			var gioParams = {
				module_pvar: "2021DTF大会",
				category1_pvar:this.$route.meta.category,
				category2_pvar:this.title,
				title_pvar:document.title,
				url_pvar:window.location.href
			}
			gio('page.set', gioParams);
		},
		swiperInit(){
			var initialSlide = 0;
			this.branch.map((item,index)=>{
				if(item.id == this.tab.id){
					initialSlide = index;
				}
			})
			this.swiper = new Swiper('#swiper-branch',{
				initialSlide:initialSlide,
				slidesPerView:this.branch.length > 3 ? 3.5 : 3,
				spaceBetween: 15,
				slidesOffsetAfter:2,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		statusText(status){
			var text = ["敬请期待","即将开始","正在直播","已结束","直播回放"];
			return text[status-1];
		},
		branchLiveBtn(item){
			var list = item.list;
			var status;
			var arr = [];
			var text = "敬请期待";
			for(var i =0;i<list.length;i++){
				status = this.sessionStatus(item,list[i],i);
				arr.push(status);
			}
			for(var i =0;i<arr.length;i++){
				if(arr[i] == 4){
					text = "直播回放";
				}
				if(arr[i] == 3){
					text = "观看直播";
					break;
				}
			}
			return text;
		},
		toMudu(item,vv = '',i = ''){
			var status = this.sessionStatus(item,vv,i);
			if(!this.tool.array.inArray(this.live_active,status)){
				return false;
			}
			if(item.live_url){
				window.open(item.live_url,'_blank');
			}else{
				var live_code = item.live_code;
				if(Number(item.live_status) === 5){
					live_code = vv.live_code;
				}
				//var url = this.global.MUDU_HOST +live_code;
				if(this.$store.state.user_info.id){
					var router = this.$router.resolve({
						path:"/auth",
						query:{
							live_event:item.live_event,
							live_code:live_code,
							live_type:item.live_type,
							title:item.title,
							branch:2
							//redirect:url
						}
					});
					window.open(router.href, '_blank');
				}else{
					var from = `/auth?live_code=${live_code}&live_type=${item.live_type}&live_event=${item.live_event}&title=${item.title}&branch=2`;
					this.util.showAuth({
						show:true,
						from:from
					});
				}
			}
		},
		inStar(row){
			return  this.star_list.find((item,index)=>{
				return Number(item.topic_id) === Number(row.id)
			})
		},
		star(item,branch = {}){
			if(!this.is_login){
				this.util.showAuth({
					show:true,
					from:"/branch"
				});
			}else{
				this.http.request({
					api:"user/star",
					data:{
						type:2,
						topic_id:item.id,
						branch_id:branch.id || '',
					},
					success:(res)=>{
						this.getStarList();
					}
				})
			}
		},
		getStarList(){
			if(!this.is_login){
				return false;
			}
			this.http.request({
				api:"user/starList",
				data:{
					type:2,
				},
				success:(res)=>{
					this.star_list = res.list;
				}
			})
		},
		sessionStatus(data,item,index){
			if(data.live_status > 0){
				return data.live_status;
			}else{
				var now_time = this.now_time;
				if(now_time < parseInt(item.live_start)){
					if(index == 0){
						if(now_time < parseInt(item.live_start) - 30*60){
							return 1;
						}else{
							return 2;
						}
					}else{
						return 1;
					}
				}else if(now_time >= parseInt(item.live_start) && now_time < parseInt(item.live_end)){
					return 3;
				}else{
					return 4;
				}
			}
		},
		getBranch(){
			this.http.request({
				api:"branch/getBranch",
				success:(res)=>{
					var branch = res.list;
					var time_list = [];
					branch.map((item,index)=>{
						var topic = item.list;
						topic.map((v,i)=>{
							time_list.push(v.live_start);
							time_list.push(v.live_end);
						})
					})
					this.branch = branch;
					this.checkTab();
					this.time_list = time_list;
					this.data_loading = false;

					if(this.tool.other.getUrlParams('timer') == 'local'){
						this.now_time = Math.floor(new Date().getTime()/1000);
					}else{
						this.now_time = res.service_time;
					}

					this.$nextTick(()=>{
						this.swiperInit();
						this.refresh();
						this.util.showBottom(true);
            this.fuckSister();
					})
				}
			})
		},
		checkMudu(){
			//https://dtf.dellemc-solution.com/#/auth?live_code=m9g528b7&redirect=http://dtf.evp.mudu.tv/watch/m9g528b7
			var branch_code = this.util.getUrlParams('branch_code');
			if(!branch_code){
				return false;
			}
			var url = this.global.MUDU_HOST+branch_code;
			if(this.$store.state.user_info.id){
				this.$router.replace({
					path:"/auth",
					query:{
						live_code:branch_code,
						redirect:url
					}
				})
			}else{
				var from = "/auth?live_code="+branch_code+"&redirect="+url
				this.util.showAuth({
					show:true,
					from:from
				});
			}
		},
		refresh(){
			this.timer = setInterval(()=>{
				var myDate = new Date();
				this.now_time = parseInt(myDate.getTime()/1000)
			},1000)
		},
		getVideoList(){
			this.http.request({
				api:"video/getVideoList",
				data:{
					type:4,
				},
				success:(res)=>{
					this.adv4 = res.list;
				}
			})
		},
    fuckSister() {
      const dom = document.querySelectorAll(".list.active .fuck-your-sister.active")[0];
      if (dom) {
        let top = document.querySelector(".m-header .top");
        if (top) {
          top = top.offsetHeight ? top.offsetHeight + 10 : 70;
        }
        const t = dom.getBoundingClientRect().top - top;
        document.body.scrollTop = document.documentElement.scrollTop = t;
      }
    },
	},
	mounted() {
		this.query = this.$route.query;
		this.setTitle();
		this.getBranch();
		this.getVideoList();
		this.checkMudu();
		this.getStarList();
	},
	destroyed() {
		clearInterval(this.timer);
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{padding: .3rem;background-color: #F2F2F2;
	.result{
		.branch{
			.swiper-container{padding:.1rem;
				.item{height:1.2rem;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;background-repeat: no-repeat;background-position: center center;background-size: 100% 100%;
					.cen{display: inline-block;
						.middle{text-align: center;transition: all .3s ease;height:1.2rem;
							.icon{width:.58rem;height:.41rem;margin: 0 auto;
								img{display: block; width: 100%;height:100%;object-fit: contain;}
							}
							.icon-a{display: none;margin: 0 auto;}
							.tit{color:#2d576f;font-size:.24rem;line-height:.31rem;margin-top: .1rem;}
						}
					}
				}
				.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: 100% 100%;
					.cen{
						.middle{
							.icon{display: none;}
							.icon-a{display: block;}
							.tit{color:#ffffff;}
						}
					}
				}
				.item:nth-last-child(1){margin-right: 0;}
			}
		}
		.title-box{padding: .2rem 0;color:#0672cb;font-size: .36rem;font-weight: bold;margin-bottom: .1rem;
			span{margin-right: .2rem;}
		}
		.session{margin-top: .2rem;padding: 0 .1rem;
			.list{display: none;
				.description{padding-top:.12rem;text-indent:.6rem; font-size:.24rem;line-height: .36rem;color:#444;background: url("~@/assets/image/2021/19.png") no-repeat top left;background-size:.44rem;}
				.box{margin-top: .3rem;overflow: hidden;padding: .1rem 0;
					.item{position: relative;display: flex;flex-wrap: wrap;overflow: hidden;
						.time-box{display: flex;flex-direction: column;width: 1.2rem;
							.line{position: relative;}
							.line::after{content: "";display: block;position: absolute;left:.15rem;top:0;width: 1px;height:100%;background: #979797;}
							.line-1{height:.2rem;}
							.line-2{flex: 1;}
							.time{font-size:.24rem;line-height:.3rem; font-weight: bold;text-align: right;position: relative;
								i{width: .3rem;height:.3rem; display: block;padding: .1rem 0; background: url("~@/assets/image/2021/14.png") no-repeat left center;background-size:.29rem;}
								.t{position: absolute;left:.4rem;top:.13rem;width: .75rem;}
							}
						}
						.info-box{padding-bottom:.3rem;flex: 1;
							.info{margin-left:.3rem; width: 4.5rem; padding:.25rem .25rem .55rem;background: #fff;box-shadow: 0 0 .1rem .02rem  rgba(0,0,0,.1);position: relative;
								.title{font-size:.24rem;font-weight: bold;color:#1A1A1A;}
								.speaker{font-size:.22rem;line-height: .33rem; color:#808080;margin-top: .1rem;
									.ll{display: flex;
										span,i{display: block;float: left;}
										span:nth-child(1){min-width: .7rem;display: inline-block;text-align: justify;text-align-last: justify;}
										i{padding: 0 .1rem;}
										span:nth-last-child(1){flex: 1;}
									}
								}
								.issue{margin-top: .1rem; padding-top: .3rem;background: url("~@/assets/image/2021/18.png") no-repeat top center;background-size: 100% .16rem;overflow: hidden;
									.ll{display: flex;flex-wrap: wrap;margin-bottom:.4rem;
										.tit{font-size:.22rem;color:#376f84;font-weight: bold;}
										.speaker-ll{font-size:.22rem;line-height: .33rem; color:#808080;margin-top:.1rem;display: flex;
											span,i{display: block;float: left;}
											span:nth-child(1){min-width: .7rem;display: inline-block;text-align: justify;text-align-last: justify;}
											i{padding: 0 .1rem;}
											span:nth-last-child(1){flex: 1;}
										}
									}
									.ll:nth-child(2n){margin-right: 0;}
								}
								.status-box{position: absolute;bottom:0;right:0;display: flex;
									.status{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#9F9F9F;color:#fff;font-size: .22rem;border-right: 1px solid #fff;
										p{padding-left:.2rem;background: url("~@/assets/image/2021/16.png") no-repeat left center;background-size:.12rem;display: inline-block;}
									}
									.status.active{background:#0672cb;}
									.star{width:1.35rem;height:.45rem;text-align: center;line-height:.5rem;background:#0672cb;color:#fff;font-size: .22rem;
										p{padding-left:.22rem;background: url("~@/assets/image/2022/10.png") no-repeat left center;background-size:.18rem;display: inline-block;}
										p::after{content: "收藏"}
									}
									.star.active{background:#9F9F9F;
										p{background-image: url("~@/assets/image/2022/11.png");background-size: .18rem;}
										p::after{content: "已收藏"}
									}
								}
							}
						}
					}
					.item.active{cursor: pointer;
						.time{background: url("~@/assets/image/2024/mobile/live_icon.png") no-repeat left center;background-size: .29rem;
              i{
                background-image: none;
              }
            }
					}
					.item:nth-last-child(1){padding-bottom: 0;}
				}
			}
			.list.active{display: block;}
		}
	}
}
.common-title{overflow:hidden;font-size:.41rem;line-height: .54rem;color:#C8C9C7;padding: .25rem 0;
	.title{color:#41B6E6;}
	.en-title{margin-left:.1rem;font-weight: 100;}
	.more{font-size: .22rem;color:#808080;padding-right: .12rem;background: url("~@/assets/image/58_2.png") no-repeat right center;background-size: .1rem;}
}
.s5{display:none;clear: both;padding:.5rem .4rem 1rem; background: url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:cover; position: relative;
	.common-title{margin-left: .1rem;}
	.content{
		.list{overflow: hidden;
			.item{float: left;width:3.2rem;margin-right:.29rem;text-align: left;transition: all .3s ease;
				.image-box{position: relative;
					.image{height:1.72rem;background:url("~@/assets/image/11.png") no-repeat center center;background-size: cover;position: relative;
						.play{width: .5rem;height:.5rem;position: absolute;top:50%;left:50%;background: url("~@/assets/image/2021/7.png") no-repeat left center;background-size: contain;margin-left: -.25rem;margin-top: -.25rem; cursor: pointer;z-index: 2;}
					}
					.image::after{content: "";display: block;position: absolute;top:0;left:0;width: 100%;height:100%; background: rgba(0,0,0,.5);z-index: 1;}
					.tit{font-size: .14rem;position: absolute;bottom:0;right:0;width: .8rem;height:.3rem;line-height: .3rem;padding-left: .2rem; background: url("~@/assets/image/2021/27.png") no-repeat center center;background-size: 100% 100%;text-align: center;color: #fff;z-index: 2;}
				}
				.info{margin-top: .2rem; box-sizing: border-box;
					.min-tit{font-size:.24rem;color:#666666;line-height:.33rem;min-height:.66rem; -webkit-line-clamp: 2;}
				}
			}
			.item:nth-child(2n){margin-right: 0;}
		}
	}
}
.footer{height:4rem;line-height: 4rem;text-align: center;color:#999;font-size: .24rem;}
</style>

